export default __webpack_public_path__ + "static/3d-featured-bf782e6d2d78ac580c080fb04404ba01.jpg";